export const CoreOrganizationsAllName = 'CoreOrganizationsAll';
